<div class="container" style="display: flex; flex-direction: column; width: 100%;margin-bottom: 30px;">
  <div style="display: flex; flex-direction: row; justify-content: center; gap: 20px;">
    <app-form-text-edit  class="col-xl-2" i18n-label label="Matricula" [(value)]="this.matricula" ></app-form-text-edit>
      <!-- <mat-paginator #paginator [pageIndex]="0" [pageSize]="this.filter.paginator.pageSize" [pageSizeOptions]="[20, 40, 60, 100]"></mat-paginator> -->
      <app-form-date-edit  i18n-label label="Desde" [(value)]="this.datainici" type="calendar"></app-form-date-edit>
      <app-form-date-edit  i18n-label label="Fins" [(value)]="this.datafi" type="calendar"></app-form-date-edit>
    <button class="btn btn-primary" style="vertical-align: middle; height: 30px;" (click)="Consultar()" i18n>Consultar</button>
  </div>
    
</div>